import React from 'react'

const ber = () => {
  return (
    <div>
        
<div class="container">
  <div class="table">
    <div class="glassHead">
      <div class="strawContainer">
        <div class="straw">
        </div>
        <div class="lemon">
        </div>
        <div class="ice">
        </div>
        <div class="ice ice2">
        </div>
        <div class="ice ice3">
        </div>
      </div>
    </div>
    <div class="liquid2">
    </div>
    <div class="liquid">
    </div>
    <div class="glassBar">
    </div>
    <div class="glassFoot">
    </div>
  </div>
  
</div>
    </div>
  )
}

export default ber